<script lang="ts">
  import { getCommonTranslations } from '@athena-lib/commonTranslationsContext';
  import { ShoppingBag } from '@athena-lib/Icons';

  const {
    countPromise,
    sizeClass,
    onClick,
  }: {
    countPromise: Promise<number>;
    sizeClass: `h-${number} w-${number}`;
    onClick: () => void;
  } = $props();

  const translations = getCommonTranslations();
</script>

<button
  type="button"
  onclick={onClick}
  aria-label={translations.goToCheckout}
  data-sveltekit-reload
>
  <span class="relative">
    <ShoppingBag {sizeClass} />
    {#await countPromise then itemsInCart}
      {#if itemsInCart}
        <div
          class={'c-cart-counter absolute -right-4 -top-4 h-5 w-5 content-center rounded-full bg-st-yellow text-center text-xs text-st-black supports-firefox:-right-10'}
        >
          {itemsInCart}
        </div>
      {/if}
    {:catch _error}
      <div
        class={'c-cart-counter absolute -right-4 -top-4 h-5 w-5 content-center rounded-full bg-red-400 text-center text-xs text-st-black supports-firefox:-right-10'}
      >
        !
      </div>
    {/await}
  </span>
</button>
